export const LectureObjectives = [
    {
        objective: 'Some indiscreetly including after far unbo',
        completed: true
    },
    {
        objective: 'Unpleasant astonished an dim',
        completed: true
    },
    {
        objective: 'Precarious beyond ouch armadillo as accurat',
        completed: true
    },
    {
        objective: 'Some indiscreetly including after far unbo',
        completed: false
    },
    {
        objective: 'Much opposite up shoddy sensitive unsucce',
        completed: false
    },
    {
        objective: 'More preparatory much derisively f',
        completed: false
    },
    {
        objective: 'Goodness tough much yikes more far pre-set far',
        completed: false
    },
    {
        objective: 'Some indiscreetly including after far unbo',
        completed: false
    },
    {
        objective: 'On recommend tolerably my belonging or am. M',
        completed: false
    },
    {
        objective: 'Some indiscreetly including after far unbo',
        completed: false
    }
];


// WEBPACK FOOTER //
// ./src/data/lectureObjectives.js